import { useStytchMemberSession } from '@stytch/react/b2b'
import { WORKSPACE_EDITOR_ROLE, WORKSPACE_OWNER_ROLE } from 'honeygrid-types'
import { useMemo } from 'react'

export const useCanEditWorkspace = () => {
	const { session } = useStytchMemberSession()

	const canEdit = useMemo(() => {
		if (!session) return false

		// Check if user has stytch_admin or workspace_editor roles
		const roles = session.roles || []
		return roles.some((role) => role === WORKSPACE_OWNER_ROLE || role === WORKSPACE_EDITOR_ROLE)
	}, [session])

	return canEdit
}
